import "./FabFootage.css";

function FabFootage({ page, settings }) {
 const content = page?.content || {};
 const themeMode =
  String(settings?.theme_mode || "dark").trim().toLowerCase() === "light"
   ? "light"
   : "dark";

 const title = content.title?.trim() || "LEAGUE FOOTAGE";

 const videos = Array.isArray(content.videos) && content.videos.length
  ? content.videos.filter(Boolean)
  : [
   "https://www.youtube.com/embed/swNunrYcFOU",
   "https://www.youtube.com/embed/OCLmxKPwzhw",
   "https://www.youtube.com/embed/YtE4nCzLNZ0",
  ];

 return (
  <div className={`fab-league-footage ${themeMode}`}>
   <div className="fab-league-footage__inner">
    <h1>{title}</h1>

    <div className="fab-league-footage__grid">
     {videos.map((video, index) => (
      <div className="fab-league-footage__video" key={`${video}-${index}`}>
       <iframe
        src={video}
        title={`FAB Video ${index + 1}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
       />
      </div>
     ))}
    </div>
   </div>
  </div>
 );
}

export default FabFootage;